import { MouseEventHandler, ReactNode } from "react"
import { PlusIcon } from "components/ui/icons/plus/PlusIcon"
import { ButtonSecondary } from "../ButtonSecondary/ButtonSecondary"
import style from "./ButtonPlus.module.scss"

const { buttonPlus } = style

type Props = {
	children?: ReactNode
	type?: "button" | "submit" | "reset"
	onClick: MouseEventHandler
	className?: string
	active?: boolean
}

export const ButtonPlus = ({ children, type, onClick, className = "", active }: Props) => {
	return (
		<ButtonSecondary
			className={`${buttonPlus} ${className}`}
			type={type}
			onClick={onClick}
			submittable={active}
			data-testid="button-plus"
		>
			<PlusIcon />
			{children}
		</ButtonSecondary>
	)
}
